module.exports = __webpack_public_path__ + "assets/img/aboutUS-module6-3.8aacaab0.jpg";